export default __webpack_public_path__ + "static/media/Mask_Group_48.6e0a5017.svg";